import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import OText from 'components/CText/OText';

const CardOfferInfoBlock = props => {
  const { oneClickApplicationOffer, onMouseClickDetails } = props;
  return (
    <FlexContainer className="flex-column width100 margt70 m-margt28">
      <FlexContainer className="m-flex-column">
        <FlexContainer className="flex-column width100 margb50 m-margb8 m-items-align-center">
          <Label
            type="Subtitle-3"
            className="Body-2 text-22 text-center d-hide"
            color="fontWhite"
          >
            <OText text={oneClickApplicationOffer?.name} />
          </Label>
          <img
            alt="credit card"
            src={`${oneClickApplicationOffer?.imageLink}`}
            className="borderRadius3 pointer imgCardSize m-margt22"
          />
        </FlexContainer>
        <FlexContainer className="flex-column width100 justify-center m-items-align-center">
          <Label type="Subtitle-2" className="Body-2 text-28 m-hide">
            <OText text={oneClickApplicationOffer?.name} />
          </Label>
          <Label
            type="Subtitle-3"
            color="fontBlue100"
            className=" otherLink margT10 text-16"
            onClick={onMouseClickDetails}
          >
            Card details
          </Label>
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default CardOfferInfoBlock;
